import { ErrorType } from '@kinopoisk-int/evgen-web-events/web/named_enums';

import { useDependencies } from '@/scenarios/legacy-player/hooks/analytics/use-dependencies';

export interface ChannelProgramModalErrorCallbackInfo {
    message: string;
    name?: string;
}

interface UiParams {
    channelId: string;
    channelName?: string;
}

interface Params {
    uiParams: UiParams;
    dependencies: ReturnType<typeof useDependencies>;
    callbackParams: [ChannelProgramModalErrorCallbackInfo];
}

export function buildChannelProgramModalErrorParams({
    uiParams,
    dependencies: _dependencies,
    callbackParams,
}: Params) {
    const { channelId, channelName } = uiParams;
    const tvProgramrequestId = 'getProgramByChannelId';
    const [error] = callbackParams;

    return {
        channelName: channelName ?? 'NONE',
        errorType: ErrorType.BackendError,
        errorTitle: error.name || 'NONE',
        errorMessage: error.message || 'NONE',
        requestId: tvProgramrequestId || 'NONE',
        channelId,
    };
}
